import axios from 'axios';
import { notificationController } from '@app/controllers/notificationController';
import i18n from '../i18n';

const baseURL = process.env.REACT_APP_BASE_URL;
const axiosInstance = axios.create({
  baseURL: baseURL,
});

axiosInstance.interceptors.request.use((config) => {
  const authToken = sessionStorage.getItem('token');
  if (authToken) {
    config.headers.set('Authorization', `Bearer ${authToken}`);
  } else {
    config.headers.delete('Authorization');
  }
  return config;
});
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    handleErrorResponse(error.response);
    return Promise.reject(error);
  },
);

export function onGet<T>(url: string, query?: unknown): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    setTimeout(() => {
      axiosInstance
        .get(url + getParameterString(query))
        .then((response) => {
          console.log(response);
          resolve(response.data.Data as T);
        })
        .catch((error) => {
          handleErrorResponse(error.response);
          reject(error.response);
        });
    }, 1);
  });
}

export function onPost<T>(url: string, data?: unknown): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    setTimeout(() => {
      axiosInstance
        .post(url, data)
        .then((response) => {
          if (response.data.Status == 200) {
            resolve(response.data.Data as T);
          } else {
            handleErrorResponse(response.data);
            reject(response.data);
          }
        })
        .catch((error) => {
          console.log(error);
          handleErrorResponse(error.response);
          reject(error.response);
        });
    }, 1);
  });
}
export function onPostFormData<T>(url: string, formData: FormData): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    setTimeout(() => {
      axiosInstance
        .post(url, formData)
        .then((response) => {
          if (response.data.Status == 200) {
            resolve(response.data.Data as T);
          } else {
            handleErrorResponse(response.data);
            reject(response.data);
          }
        })
        .catch((error) => {
          console.log(error);
          handleErrorResponse(error.response);
          reject(error.response);
        });
    }, 1);
  });
}
export interface dataMessage {
  Message: string;
}

export interface ApiErrorData {
  Message: string;
  Data: dataMessage;
  Status: number;
}

export interface ApiResData {
  Message: string;
  data: dataMessage;
  Status: number;
}

const handleErrorResponse = (error: ApiErrorData): void => {
  if (error && error?.Message) {
    if (error.Status === 401) {
      notificationController.error({ message: i18n.t('Phiên làm việc đã hết. Vui lòng truy cập lại') as string });
      localStorage.clear();
      window.location.href = '/';
    } else {
      notificationController.error({ message: i18n.t(error?.Message) as string });
    }
  } else if (error?.Status >= 500) {
    notificationController.error({ message: 'Có lỗi xảy ra, vui lòng thử lại' });
  }
};

const getParameterString = (parameters?: unknown): string => {
  if (!parameters) return '';
  const keys = Object.keys(parameters) as Array<keyof typeof parameters>;
  const parameterStrings = keys
    .filter((key) => !!parameters[key])
    .map(
      (key) => `${key}=${typeof parameters[key] === 'string' ? (parameters[key] as string).trim() : parameters[key]}`,
    );
  return parameterStrings.length === 0 ? '' : `?${parameterStrings.join('&')}`;
};

export default axiosInstance;
